import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "../../../../api/api";
import InputField from "../../../../components/InputField";
import Button from "../../../../components/Button";
import { useAuth } from "../../../../context/AuthContext";
import { Modal } from "react-bootstrap";
import "../../Common/form.css";
import Breadcrumbs from "../../../../components/Breadcrumbs";

const ViewQuotation = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [quotation, setQuotation] = useState(null);
  // console.log("quotation", quotation);

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [acceptLoading, setAcceptLoading] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [callbackLoading, setCallbackLoading] = useState(false);
  const [showConfirmCallback, setShowConfirmCallback] = useState(false);
  const [showSuccessCallback, setShowSuccessCallback] = useState(false);
  const [showConfirmSales, setShowConfirmSales] = useState(false);
  const [isConfirmedSales, setIsConfirmedSales] = useState(false);
  const { user } = useAuth() || {};
  // console.log("userrrr", user?.user_role);

  useEffect(() => {
    const fetchQuotation = async () => {
      try {
        const response = await api.get(`/quotation/viewQuotation/${id}`);
        console.log("response.data", response.data);

        setQuotation(response.data);
      } catch (err) {
        setError("Failed to fetch quotation.");
      } finally {
        setLoading(false);
      }
    };
    fetchQuotation();
  }, [id]);

  // Handle accept quotation
  const handleAcceptQuotation = () => {
    if (user?.user_role === "sales_rep" || user?.user_role === "Admin" || user?.user_role === "SuperAdmin") {
      setShowConfirmSales(true);
      setIsConfirmedSales(false);
    } else {
      setShowConfirm(true);
    }
  };

  const handleConfirmAccept = async () => {
    setShowConfirm(false);
    setAcceptLoading(true);
    try {
      await api.put(`/quotation/acceptQuotation/${id}`);
      setShowSuccess(true);
    } catch (err) {
      alert("Failed to accept quotation. Please try again.");
      console.error("Accept quotation error:", err);
    } finally {
      setAcceptLoading(false);
    }
  };

  const handleConfirmAcceptSales = async () => {
    setShowConfirmSales(false);
    setAcceptLoading(true);
    try {
      await api.put(`/quotation/acceptQuotation/${id}`);
      setShowSuccess(true);
    } catch (err) {
      alert("Failed to accept quotation. Please try again.");
      console.error("Accept quotation error:", err);
    } finally {
      setAcceptLoading(false);
    }
  };

  const handleCancelAcceptSales = () => {
    setShowConfirmSales(false);
    setIsConfirmedSales(false);
  };

  const handleSuccessClose = () => {
    setShowSuccess(false);
    if (user?.user_role === "sales_rep") {
      navigate("/freight-enquiries");
    } else if (user?.user_role === "Admin" || user?.user_role === "SuperAdmin") {
      navigate("/freight/pending-enquiries");
    } else {
      navigate("/my-bookings/list-of-bookings");
    }
  };

  // Handle request callback
  const handleRequestCallback = () => {
    setShowConfirmCallback(true);
  };

  const handleConfirmCallback = async () => {
    setShowConfirmCallback(false);
    setCallbackLoading(true);
    try {
      await api.put(`/quotation/requestCallback/${id}`);
      setShowSuccessCallback(true);
    } catch (err) {
      alert("Failed to request callback. Please try again.");
      console.error("Request callback error:", err);
    } finally {
      setCallbackLoading(false);
    }
  };

  const handleSuccessCallbackClose = () => {
    setShowSuccessCallback(false);
    navigate("/my-enquiry/view-enquiry");
  };

  if (loading) return <p>Loading...</p>;
  if (error) return <p>{error}</p>;
  if (!quotation) return <p>No quotation found.</p>;

  return (
    <>
      <Breadcrumbs />
      <div className="row mb-3 g-3">
        <div className="col-sm-6 col-md-4">
            <InputField
            label="Booking Party Name"
            defaultValue={quotation.client_name}
            value={quotation.client_name}
            disabled={true}
          />
        </div>
        <div className="col-sm-6 col-md-4">
          <InputField
            label="Booking Company Name"
            disabled={true}
            defaultValue={quotation.client_company}
            value={quotation.client_company}
          />
        </div>
        <div className="col-sm-6 col-md-4">
          <InputField
            label="CHA Services Required?"
            disabled={true}
            defaultValue={quotation.cha_required}
            value={quotation.cha_required}
          />
        </div>

        {/* Dates */}
        <div className="col-sm-6 col-md-4">
          <InputField
            label="Creation Date"
            disabled={true}
            defaultValue={quotation.creation_date}
            value={quotation.creation_date}
          />
        </div>
        <div className="col-sm-6 col-md-4">
          <InputField
            label="Valid till Date"
            disabled={true}
            defaultValue={quotation.valid_till_date}
            value={quotation.valid_till_date}
          />
        </div>

        {/* Shipment & Port Info */}
        <div className="col-sm-6 col-md-4">
          <InputField
            label="Incoterm"
            disabled={true}
            defaultValue={quotation.incoterm}
            value={quotation.incoterm}
          />
        </div>
        <div className="col-sm-6 col-md-4">
          <InputField
            label="Shipper Name"
            disabled={true}
            defaultValue={quotation.first_shipper_name}
            value={quotation.first_shipper_name}
          />
        </div>
        <div className="col-sm-6 col-md-4">
          <InputField
            label="Consignee Name"
            disabled={true}
            defaultValue={quotation.first_consignee_name}
            value={quotation.first_consignee_name}
          />
        </div>
        <div className="col-sm-6 col-md-4">
          <InputField
            label="Port of Loading"
            disabled={true}
            defaultValue={quotation.pol}
            value={quotation.pol}
          />
        </div>
        <div className="col-sm-6 col-md-4">
          <InputField
            label="Port of Discharge"
            disabled={true}
            defaultValue={quotation.pod}
            value={quotation.pod}
          />
        </div>
        <div className="col-sm-6 col-md-4">
          <InputField
            label="Freight Terms"
            disabled={true}
            defaultValue={quotation.freight_terms}
            value={quotation.freight_terms}
          />
        </div>
        <div className="col-sm-6 col-md-4">
          <InputField
            label="Routing"
            disabled={true}
            defaultValue={quotation.routing}
            value={quotation.routing}
          />
        </div>
        {["Indirect", "Both"].includes(quotation.routing) && (
          <div className="col-sm-6 col-md-4">
            <InputField
              label="Transshipment Hub"
              disabled={true}
              defaultValue={quotation.transshipment_hub}
              value={quotation.transshipment_hub}
            />
          </div>
        )}

        {/* Place Of Receipt / POR Pin Code */}
        {["Door to Door", "ICD to Door", "Door to Port", "ICD to Port"].includes(
          quotation.incoterm,
        ) && (
          <>
            <div className="col-sm-6 col-md-4">
              <InputField
                label="Place Of Receipt"
                disabled={true}
                defaultValue={quotation.place_of_receipt}
                value={quotation.place_of_receipt}
              />
            </div>
            <div className="col-sm-6 col-md-4">
              <InputField
                label="POR Pin Code"
                disabled={true}
                defaultValue={quotation.place_of_receipt_pin}
                value={quotation.place_of_receipt_pin}
              />
            </div>
          </>
        )}

        {/* Final Port Of Delivery / FPOD Pin Code */}
        {["Door to Door", "ICD to Door", "Port to Door"].includes(
          quotation.incoterm,
        ) && (
          <>
            <div className="col-sm-6 col-md-4">
              <InputField
                label="Final Port Of Delivery"
                disabled={true}
                defaultValue={quotation.final_port_of_delivery}
                value={quotation.final_port_of_delivery}
              />
            </div>
            <div className="col-sm-6 col-md-4">
              <InputField
                label="FPOD Pin Code"
                disabled={true}
                defaultValue={quotation.final_port_of_delivery_pin}
                value={quotation.final_port_of_delivery_pin}
              />
            </div>
          </>
        )}

        {/* Shipping Segment */}
        <div className="col-sm-6 col-md-4">
          <InputField
            label="Shipment Segment"
            disabled={true}
            defaultValue={quotation.shipment_segment}
            value={quotation.shipment_segment}
          />
        </div>
        {["FE", "LE"].includes(quotation.shipment_segment) && (
          <div className="col-sm-6 col-md-4">
            <InputField
              label="Stuffing At"
              disabled={true}
              defaultValue={quotation.stuffing_destuffing_At}
              value={quotation.stuffing_destuffing_At}
            />
          </div>
        )}
        {quotation.stuffing_destuffing === "Destuffing" && (
          <div className="col-sm-6 col-md-4">
            <InputField
              label="Destuffing At"
              disabled={true}
              defaultValue={quotation.stuffing_destuffing_At}
              value={quotation.stuffing_destuffing_At}
            />
          </div>
        )}

        {/* Cargo Info */}
        <div className="col-sm-6 col-md-4">
          <InputField
            label="Nature of Cargo"
            disabled={true}
            defaultValue={quotation.nature_of_cargo}
            value={quotation.nature_of_cargo}
          />
        </div>

        {/* Conditional Hazardous */}
        {quotation.nature_of_cargo === "Hazardous" && (
          <div className="col-sm-6 col-md-4">
            <InputField
              label="HAZ Class"
              disabled={true}
              defaultValue={quotation.haz_class}
              value={quotation.haz_class}
            />
          </div>
        )}

        {/* Document Type */}
        <div className="col-sm-6 col-md-4">
          <InputField
            label="Document Type"
            disabled={true}
            defaultValue={quotation.document_type}
            value={quotation.document_type}
          />
        </div>

        {quotation.document_type === "Original" && (
          <div className="col-sm-6 col-md-4">
            <InputField
              label="Document Count"
              disabled={true}
              defaultValue={quotation.document_count}
              value={quotation.document_count}
            />
          </div>
        )}
        {quotation.switch_bl === "Yes" && (
          <div className="col-sm-6 col-md-4">
            <InputField
              label="Switch BL"
              disabled={true}
              defaultValue={quotation.switch_at}
              value={quotation.switch_at}
            />
          </div>
        )}
        {/* HS Code & Description */}
        <div className="col-sm-6 col-md-4">
          <InputField
            label="HS Code"
            disabled={true}
            defaultValue={quotation.hs_code}
            value={quotation.hs_code}
          />
        </div>
        <div className="col-sm-6 col-md-4">
          <InputField
            label="HSN Description"
            disabled={true}
            defaultValue={quotation.hs_description}
            value={quotation.hs_description}
          />
        </div>
      </div>

      {quotation.containers?.length ? (
        <div className="ovrflw">
          <table className="table table-bordered">
            <thead>
              <tr>
                {!["LE", "LI"].includes(quotation.shipment_segment) && (
                  <th>Container Type</th>
                )}
                {!["LE", "LI"].includes(quotation.shipment_segment) && (
                  <th>Gross Cargo Weight</th>
                )}
                {!["FE", "FI"].includes(quotation.shipment_segment) && (
                  <th>Length</th>
                )}
                {!["FE", "FI"].includes(quotation.shipment_segment) && (
                  <th>Breadth</th>
                )}
                {!["FE", "FI"].includes(quotation.shipment_segment) && (
                  <th>Height</th>
                )}
                {["LE", "LI"].includes(quotation.shipment_segment) && <th>CBM</th>}
                {quotation.nature_of_cargo === "Temperature Control" && (
                  <th>Temperature</th>
                )}
              </tr>
            </thead>
            <tbody>
              {quotation.containers.map((c) => (
                <tr key={c.container_id}>
                  {!["LE", "LI"].includes(quotation.shipment_segment) && (
                    <td>
                      <InputField value={c.container_type} disabled={true} />
                    </td>
                  )}
                  {!["LE", "LI"].includes(quotation.shipment_segment) && (
                    <td>
                      <InputField value={c.container_weight} disabled={true} />
                    </td>
                  )}
                  {!["FE", "FI"].includes(quotation.shipment_segment) && (
                    <td>
                      <InputField value={c.container_length} disabled={true} />
                    </td>
                  )}
                  {!["FE", "FI"].includes(quotation.shipment_segment) && (
                    <td>
                      <InputField value={c.container_breadth} disabled={true} />
                    </td>
                  )}
                  {!["FE", "FI"].includes(quotation.shipment_segment) && (
                    <td>
                      <InputField value={c.container_height} disabled={true} />
                    </td>
                  )}
                  {["LE", "LI"].includes(quotation.shipment_segment) && (
                    <td>
                      {c.container_length && c.container_breadth && c.container_height
                        ? (
                            (parseFloat(c.container_length) *
                              parseFloat(c.container_breadth) *
                              parseFloat(c.container_height)) /
                            1000000
                          ).toFixed(2)
                        : "0.00"}
                    </td>
                  )}
                  {quotation.nature_of_cargo === "Temperature Control" && (
                    <td>
                      <InputField
                        value={c.container_temperature}
                        disabled={true}
                      />
                    </td>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
          <div className="measurement">
            <p>1M = 100CM</p>
            <p>1CM = 10MM</p>
          </div>
        </div>
      ) : (
        <p>No containers added.</p>
      )}
      <div className="row mb-3">
        <div className="col-sm-6 col-md-4">
          <InputField
            label="Packaging Type"
            disabled={true}
            defaultValue={quotation.packaging_type}
            value={quotation.packaging_type}
          />
        </div>
        <div className="col-sm-6 col-md-4">
          <InputField
            label="Packaging Count"
            disabled={true}
            defaultValue={quotation.packaging_count}
            value={quotation.packaging_count}
          />
        </div>
        <div className="col-sm-6 col-md-4">
          <InputField
            label="Credit Days"
            disabled={true}
            defaultValue={quotation.credit_days}
            value={quotation.credit_days}
          />
        </div>
        <div className="col-sm-6 col-md-4">
          <InputField
            label="Credit Amount"
            disabled={true}
            defaultValue={quotation.credit_amount}
            value={quotation.credit_amount}
          />
        </div>
        <div className="col-sm-3 col-md-4">
          <InputField
            label="Goods Value"
            disabled={true}
            defaultValue={quotation.goods_value}
            value={quotation.goods_value}
          />
        </div>
        <div className="col-sm-3 col-md-4">
          <InputField
            label="Remarks"
            disabled={true}
            defaultValue={quotation.remarks}
            value={quotation.remarks}
          />
        </div>
      </div>
      {quotation.quotation_charges?.length ? (
        <div className="d-flex" style={{ gap: "1.5rem" }}>
          <div className="ovrflw w-100">
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th>Charge Code</th>
                  <th>Currency</th>
                  <th>Amount</th>
                  <th>GST %</th>
                  <th>Quantity</th>
                  <th>Tax(INR)</th>
                  <th> GST Amount</th>
                  <th>Total</th>
                </tr>
              </thead>
              <tbody>
                {quotation.quotation_charges.map((c, idx) => (
                  <tr key={idx}>
                    <td>{c.charge_code}</td>
                    <td>{c.charge_currency}</td>
                    <td>{c.amount}</td>
                    <td>{c.gst_percentage} %</td>
                    <td>{c.quantity}</td>
                    <td>{c.tax_amount}</td>
                    <td>{c.gst_amount}</td>
                    <td>{c.total_amount}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="ovrflw fullwidth">
            <div className="table-responsive mb-4 position-relative ">
              <table className="table table-bordered tbllbl mb-2 mb-md-3">
                <thead className="table-light">
                  <tr>
                    <th>Exchange Rate</th>
                  </tr>
                </thead>
                <tbody>
                  {quotation.quotation_charges.map((c, idx) => (
                    <tr key={idx}>
                      <td className="d-flex align-items-center justify-content-between">
                        {c.exchange_rate}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      ) : (
        <p>No charges added.</p>
      )}

      {/* <div className="lstbox flex-column d-inline-flex gap-3 mb-4">
        {quotation?.quotation_charges.map((data) => (
          <div key={data.enq_id}>
            <div className="d-flex justify-content-between gap-5">
              <div>
                <p>
                  <strong className="me-2">Sub Total :</strong>
                  {data?.sub_total}
                </p>
              </div>
              <div>
                <p>
                  <strong>GST Breakup</strong>
                  {console.log("data", data)}
                </p>
                <div>
                  <p>CGST: {data?.sub_total}</p>
                  <p>SGST: {data?.sub_total}</p>
                </div>
                <p>
                  <strong>
                    <span className="me-2">GST Total : </span>
                    {data?.gst_total}
                  </strong>
                </p>
              </div>
            </div>
            <p>
              <strong className="me-2">Grand Total :</strong>{" "}
              {data?.grand_total}
            </p>
          </div>
        ))}
      </div> */}

      <div className="lstbox flex-column d-inline-flex gap-3 mb-4">
        {quotation?.quotation_charges?.length > 0 ? (
          (() => {
            const totals = quotation.quotation_charges.reduce(
              (acc, curr) => {
                const taxAmount = parseFloat(curr.tax_amount) || 0;
                const gstAmount = parseFloat(curr.gst_amount) || 0;
                const totalAmount = parseFloat(curr.total_amount) || 0;

                acc.subTotal += taxAmount;
                acc.gstTotal += gstAmount;
                acc.grandTotal += totalAmount;
                return acc;
              },
              { subTotal: 0, gstTotal: 0, grandTotal: 0 }
            );

            const formattedTotals = Object.fromEntries(
              Object.entries(totals).map(([key, val]) => [key, val.toFixed(2)])
            );

            // Extract GST percentages as array for display
            const gstPercentages = quotation.quotation_charges
              .map((c) => c.gst_percentage / 2)
              .filter((p) => p !== undefined && p !== null);

            return (
              <>
                <div className="d-flex justify-content-between gap-5">
                  <div>
                    <p>
                      <strong className="me-2">Sub Total :</strong> ₹
                      {formattedTotals.subTotal}
                    </p>
                  </div>
                  <div>
                    <p>
                      <strong>GST Breakup</strong>
                    </p>
                    <div>
                      <p>
                        CGST: {gstPercentages.map((p) => `${p} %`).join(" ")}
                      </p>
                      <p>
                        SGST: {gstPercentages.map((p) => `${p} %`).join(" ")}
                      </p>
                    </div>
                    <p>
                      <strong>
                        <span className="me-2">GST Total :</span> ₹
                        {formattedTotals.gstTotal}
                      </strong>
                    </p>
                  </div>
                </div>
                <p>
                  <strong className="me-2">Grand Total :</strong> ₹
                  {formattedTotals.grandTotal}
                </p>
              </>
            );
          })()
        ) : (
          <p>No charges available.</p>
        )}
      </div>

      <h3 className="page-title">Terms & Conditions</h3>
      {quotation.terms_and_conditions?.length ? (
        <ol>
          {quotation.terms_and_conditions.map((t, idx) => (
            <li key={idx} className="mb-2">
              {t}
            </li>
          ))}
        </ol>
      ) : (
        <p>-</p>
      )}
      {(user?.user_role === "User" || user?.user_role === "sales_rep" || user?.user_role === "Admin" || user?.user_role === "SuperAdmin") &&
        quotation.Status !== "Quotation Accepted" && (
        <div className="row">
          <div className="col-sm-3">
            <Button
              text={acceptLoading ? "Accepting..." : user?.user_role === "sales_rep" || user?.user_role === "Admin" || user?.user_role === "SuperAdmin" ? "Accept Quotation (Offline Approval)" : "Accept Quotation"}
              variant="primary"
              size="md"
              onClick={handleAcceptQuotation}
              disabled={acceptLoading}
            />
          </div>
          <div className="col-sm-6"></div>
          {user?.user_role === "User" && (
            <div className="col-sm-3 d-flex justify-content-end">
              <Button
                text={callbackLoading ? "Requesting..." : "Request Call Back"}
                variant="primary"
                size="md"
                onClick={handleRequestCallback}
                disabled={callbackLoading}
              />
            </div>
          )}
        </div>
      )}

      {/* Confirm Modal */}
      <Modal show={showConfirm} onHide={() => setShowConfirm(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Acceptance</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure you want to accept this quotation?</Modal.Body>
        <Modal.Footer>
          <Button
            text="Cancel"
            variant="secondary"
            onClick={() => setShowConfirm(false)}
          />
          <Button
            text="Confirm"
            variant="primary"
            onClick={handleConfirmAccept}
          />
        </Modal.Footer>
      </Modal>

      {/* Success Modal */}
      <Modal show={showSuccess} onHide={handleSuccessClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Success</Modal.Title>
        </Modal.Header>
        <Modal.Body>Quotation accepted successfully!</Modal.Body>
        <Modal.Footer>
          <Button text="OK" variant="success" onClick={handleSuccessClose} />
        </Modal.Footer>
      </Modal>

      {/* Confirm Callback Modal */}
      <Modal
        show={showConfirmCallback}
        onHide={() => setShowConfirmCallback(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Confirm Request</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure you want to Request a callback?</Modal.Body>
        <Modal.Footer>
          <Button
            text="Cancel"
            variant="secondary"
            onClick={() => setShowConfirmCallback(false)}
          />
          <Button
            text="Confirm"
            variant="primary"
            onClick={handleConfirmCallback}
          />
        </Modal.Footer>
      </Modal>

      {/* Success Callback Modal */}
      <Modal
        show={showSuccessCallback}
        onHide={handleSuccessCallbackClose}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Success</Modal.Title>
        </Modal.Header>
        <Modal.Body>Callback requested successfully!</Modal.Body>
        <Modal.Footer>
          <Button
            text="OK"
            variant="success"
            onClick={handleSuccessCallbackClose}
          />
        </Modal.Footer>
      </Modal>

      {/* Confirmation Modal for Sales Rep */}
      {showConfirmSales && (
        <div
          className="modal fade show d-block"
          tabIndex="-1"
          role="dialog"
          style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Confirm Offline Approval Acceptance</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={handleCancelAcceptSales}
                ></button>
              </div>
              <div className="modal-body">
                <p>Are you sure you want to accept this quotation on behalf of the customer?</p>
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="confirmOfflineCheckbox"
                    checked={isConfirmedSales}
                    onChange={(e) => setIsConfirmedSales(e.target.checked)}
                  />
                  <label className="form-check-label" htmlFor="confirmOfflineCheckbox">
                    I confirm that the client has given offline approval to me.
                  </label>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={handleCancelAcceptSales}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleConfirmAcceptSales}
                  disabled={!isConfirmedSales}
                >
                  Confirm
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Modal Backdrop for Sales Modal */}
      {showConfirmSales && (
        <div className="modal-backdrop fade show"></div>
      )}
    </>
  );
};

export default ViewQuotation;
